"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var form_1 = require("../../shared/form");
var hovo_api_1 = require("../../shared/hovo-api");
var messages_1 = require("../../shared/messages");
var http_1 = require("../../shared/http");
var config_1 = require("../../shared/config");
(0, jquery_1.default)(function () {
    var $form = (0, jquery_1.default)('#change-username-form');
    var $submit = $form.find('input[type="submit"]');
    $form.on('submit', function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var request, _a, url, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        request = (0, form_1.convertFormToJSON)($form);
                        _a = !request || !request.username;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, hovo_api_1.usernameExists)(request.username)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            (0, messages_1.showErrorMessage)("De gebruikersnaam is al in gebruik. Probeer een andere gebruikersnaam.");
                            return [2 /*return*/];
                        }
                        url = "".concat((0, config_1.getApiRootUrl)(), "api/site/user/change-username");
                        return [4 /*yield*/, (0, http_1.putJson)(url, request, (0, http_1.getHeaders)())];
                    case 3:
                        response = _b.sent();
                        if (response.status === 200) {
                            (0, messages_1.showSuccessMessage)("De gebruikersnaam is succesvol aangepast.");
                        }
                        else {
                            (0, messages_1.showErrorMessage)("De gebruikersnaam kon niet aangepast worden.");
                        }
                        $submit.prop("disabled", true);
                        return [2 /*return*/];
                }
            });
        });
    });
});
